module.exports = __webpack_public_path__ + "static/media/lds-logo_cs.46f2f899.svg";